module.exports = __webpack_public_path__ + "img/silvermedal.cf984893.png";